<template>
    <AppLayout>
        <div class="container flex flex-col justify-center p-4 mx-auto md:w-3/4">
            <div class="mb-4 font-bold md:text-2xl">
                Submit a complain
            </div>
            <div class="px-4 py-6 bg-white border rounded">
                <div class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-8">
                    <div class="w-40">
                        Complain Details
                    </div>
                    <div class="w-full">
                        <t-textarea
                            v-model="form.details"
                            rows="6"
                        />
                    </div>
                </div>

                <div class="flex items-center justify-end">
                    <Button
                        text="Send Request"
                        color="green"
                        @onClick="submitForm()"
                    />
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout.vue';
import Button from '../../Components/Button.vue';

export default {
    name: 'CreateComplain',

    components: {
        AppLayout,
        Button,
    },

    data() {
        return {
            form: this.$inertia.form({
                details: null,
            }),
        };
    },

    methods: {
        submitForm() {
            this.form.post(route('complains.store'), {
                onFinish: () => this.form.reset(),
            });
        },
    },
};
</script>
